import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#23718B',
        secondary: '#36ADBF',
        accent: '#8c9eff',
        error: '#b71c1c',
      },
    },
  },
});
